import {useUser} from "@/biz/user.mjs"
import {useIsProjectMember} from "@/biz/projectMember.mjs"

export default (perm, dp) => {
    const {isPlatformAdm, pkid: userId} = useUser()
    const isMember = useIsProjectMember(dp.prjId)

    const permission = (() => {
        if (perm) {
            return new Set(perm)
        }

        if ('0' !== isPlatformAdm) {
            return new Set(['revise', 'write'])
        }

        const permission = new Set

        if (isMember) {
            permission.add('revise')
        }

        const {
            crtId,
            stsCode,
            uptId,
        } = dp

        if (
            (
                'REVISE' === stsCode &&
                uptId === userId
            ) ||
            (
                'DRAFT' === stsCode &&
                crtId === userId
            )
        ) {
            permission.add('write')
        }

        return permission
    })()

    return {permission}
}
